import React from 'react';
import { useDraggable } from '@dnd-kit/core';

type Series = {
  id: string;
  label: string;
};

type DraggableSeriesItemProps = Series & {
  setDraggedItem: (item: { type: string; label: string } | null) => void;
};


const DraggableSeriesItem: React.FC<DraggableSeriesItemProps> = ({
  id,
  label,
  setDraggedItem,
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    data: { type: 'series' },
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      onMouseDown={() => setDraggedItem({ type: 'series', label })}
      onMouseUp={() => setDraggedItem(null)}
      className={`cursor-move px-2 py-1 rounded-sm border border-rule text-sm ${isDragging ? 'opacity-50' : 'bg-newsprint-dark hover:bg-newsprint'
        }`}
    >
      {label}
    </div>
  );
};

type Props = {
  series: Series[];
  setDraggedItem: (item: { type: string; label: string } | null) => void;
};

const AvailableSeries: React.FC<Props> = ({ series, setDraggedItem }) => {
  return (
    <div>
      <h3 className="font-bold mb-2">Available Series</h3>
      <div className="flex flex-col gap-2">
        {series.map((s) => (
          <DraggableSeriesItem
            key={s.id}
            id={s.id}
            label={s.label}
            setDraggedItem={setDraggedItem}
          />
        ))}
      </div>
    </div>
  );
};


export default AvailableSeries;
